/* eslint-disable react/jsx-pascal-case */
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, CircularProgress, IconButton } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import React, { Fragment } from 'react';
import { HLine, MHeading } from '../../styledComponents';
import { colors } from '../../utils';
import { Box_, Footer, Header } from './styledComponent';

const { colorWhite, colorLightBlack, colorPrimary } = colors;

export default function TransitionsModal({
	children,
	open,
	handleClose,
	handleClassName,
	modalTitle,
	width,
	height,
	padding,
	submitHandler,
	submitDisabledBtn,
	deleteHandler,
	disabledBtn,
	handler,
	handlerTitle,
	modalCloseBtn,
	modalCloseBtnTitle,
	submitBtnTitle,
	dontClose,
	isLoading
}) {


	return (
		<div>
			<Modal
				open={open}
				onClose={!dontClose && handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
				sx={{ ".MuiBox-root": { borderRadius: "2em" } }}
				style={{ zIndex: '99999 !important' }}

			>
				<Fade in={open}>
					<Box_ style={{ width: width, height: height, zIndex: '99999 !important' }} className={handleClassName}>
						<Header padding={padding} id='transition-modal-title'>
							<MHeading fs='1.8rem' fw='600'>
								{modalTitle}
							</MHeading>
							<IconButton aria-label='close' onClick={handleClose}>
								<CloseIcon style={{ color: colorWhite, fontSize: '2rem' }} />
							</IconButton>
						</Header>
						{isLoading ?
							<Box sx={{ display: "flex", justifyContent: "center", padding: "3em" }}>
								<CircularProgress size="10rem" />
							</Box> :
							<>
								<Fragment>{children}</Fragment>
								{submitHandler || (deleteHandler && <HLine />)}
								<Footer>
									{modalCloseBtn && (
										<Button
											variant='contained'
											size='large'
											style={{
												backgroundColor: colorPrimary,
												fontSize: '1.4rem',
												textTransform: 'none',
												padding: '0.5rem 3rem',
											}}
											onClick={() => handleClose()}
											className='font-face-R outlinedHover'>
											{modalCloseBtnTitle}
										</Button>
									)}

									{submitHandler && (
										<Button
											variant='contained'
											size='large'
											type='submit'
											style={{
												fontSize: '1.4rem',
												textTransform: 'none',
												padding: '0.5rem 3rem',
											}}
											disabled={submitDisabledBtn}
											onClick={() => submitHandler()}
											className='font-face-R btn-dark'>
											{submitBtnTitle || 'Submit'}

										</Button>
									)}

									{deleteHandler && (
										<Button
											variant='contained'
											size='large'
											style={{
												backgroundColor: colorLightBlack,
												fontSize: '1.4rem',
												textTransform: 'none',
												padding: '0.5rem 3rem',
											}}
											disabled={disabledBtn}
											onClick={() => deleteHandler()}
											className='font-face-R btn-dark'>
											Delete
										</Button>
									)}

									{handler && (
										<Button
											variant='contained'
											size='large'
											style={{
												backgroundColor: colorLightBlack,
												fontSize: '1.4rem',
												textTransform: 'none',
												padding: '0.5rem 3rem',
											}}
											disabled={disabledBtn}
											onClick={() => handler()}
											className='font-face-R btn-dark'>
											{handlerTitle}
										</Button>
									)}
								</Footer>
							</>
						}
					</Box_>
				</Fade>
			</Modal>
		</div>
	);
}
